import MicroModal from 'micromodal';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

window.addEventListener('load', () => {
	MicroModal.init({
		onShow: modal => {
			clearAllBodyScrollLocks()
			const navigationIsOpen = document.querySelector('.navigation-wrapper').classList.contains('is-open')
			const el = document.querySelector(`#${modal.id}`)
			navigationIsOpen && disableBodyScroll(el.querySelector('.o-modal__overlay'))
		},
		onClose: () => {
			clearAllBodyScrollLocks()
			const navigation = document.querySelector('.navigation-wrapper')
			const navigationIsOpen = navigation.classList.contains('is-open')
			navigationIsOpen && disableBodyScroll(navigation.querySelector('.wrap'))
		},
		openClass: 'is-open',
		disableScroll: true,
		disableFocus: true
	});
});



// WEBPACK FOOTER //
// ./js/modules/modal.js